import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';

export default function CompteConfirme() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (token) {
      axios.get(`/api/auth/confirm/${token}`)
        .then(() => setStatus('ok'))
        .catch(() => setStatus('error'));
    } else {
      setStatus('ok');
    }
  }, [token]);

  return (
    <div style={{ minHeight: '100vh', background: '#fafaf8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: '16px', padding: '48px', maxWidth: '440px', textAlign: 'center', border: '2px solid #c49090' }}>
        {status === 'loading' && <div style={{ fontSize: '14px', color: '#6a5050' }}>Confirmation en cours…</div>}
        {status === 'ok' && (
          <>
            <div style={{ fontSize: '52px', marginBottom: '16px' }}>✓</div>
            <h2 style={{ fontFamily: 'Georgia,serif', fontSize: '24px', color: '#1a1010', marginBottom: '10px' }}>Compte confirmé !</h2>
            <p style={{ fontSize: '13px', color: '#4a3030', lineHeight: '1.8', marginBottom: '24px' }}>Bienvenue dans la communauté MJ Fans. Vous pouvez maintenant vous connecter et partager vos témoignages.</p>
            <Link to="/connexion"><button style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: '8px', padding: '12px 28px', fontSize: '14px', fontWeight: '700', cursor: 'pointer' }}>Se connecter →</button></Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={{ fontSize: '52px', marginBottom: '16px' }}>✗</div>
            <h2 style={{ fontFamily: 'Georgia,serif', fontSize: '24px', color: '#8b1a2a', marginBottom: '10px' }}>Lien invalide</h2>
            <p style={{ fontSize: '13px', color: '#4a3030', lineHeight: '1.8', marginBottom: '24px' }}>Ce lien est invalide ou a expiré. Veuillez vous réinscrire.</p>
            <Link to="/inscription"><button style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: '8px', padding: '12px 28px', fontSize: '14px', fontWeight: '700', cursor: 'pointer' }}>S'inscrire →</button></Link>
          </>
        )}
      </div>
    </div>
  );
}
